import React from 'react'
import { Typography, TextBox, Button, Paper } from '@telavita-core/react-design-kit'

import * as S from './styles'

interface CancelReservationFormProps {
  isProfessional: boolean
  reservationWeekday: string
  reservationHour: string
  reason: string
  onSetReason: (reason: string) => void
  onSubmit: () => void
}

export const CancelReservationForm: React.FC<CancelReservationFormProps> = ({ 
  isProfessional, 
  reservationWeekday, 
  reservationHour, 
  reason, 
  onSetReason, 
  onSubmit 
}) => {
  return (
    <S.CancelReservationFormWrapper>
      <Typography variant='content2' color='danger' center>
        {isProfessional
          ? <><b>Atenção:</b> ao prosseguir, você cancelará <br /> a reserva deste paciente em todas(os) as(os)<br/><b>{reservationWeekday.toLowerCase()}, {reservationHour}</b>.</>
          : <><b>Atenção:</b> ao prosseguir, você perderá sua recorrência de horário em todas(os) as(os)<br/><b>{reservationWeekday.toLowerCase()}, {reservationHour}</b></>
        }
      </Typography>
        
      <Typography variant='content2' color='danger' center>
        Caso haja reservas avulsas em dias e/ou horários diferentes, elas também serão canceladas.
      </Typography>

      <S.TextBoxWrapper>
        <Typography variant='content2' weight='bold'>
          Motivo do cancelamento*
        </Typography>

        <Typography variant='content3' italic>
          {isProfessional 
            ? 'O paciente receberá esta mensagem como justificativa. Escreva uma mensagem amigável, como se estivesse falando com o paciente.' 
            : 'O psicólogo receberá esta mensagem como justificativa. Escreva uma mensagem amigável, como se estivesse falando com o psicólogo.'
          }
        </Typography>

        <TextBox
          maxLength={1000}
          placeholder='Digite o motivo'
          value={reason}
          onChange={({target}) => onSetReason(target.value)}
        />
      </S.TextBoxWrapper>

      {isProfessional &&
        <Paper variant='warning' customClassName='paperWarning'>
          <Typography variant='content2'>
            <b>Antes de cancelar, fale com o paciente para confirmar.</b><br/>
            Ao cancelar a reserva, o horário voltará a ser disponibilizado para outros pacientes agendarem (caso esteja cadastrado em sua disponibilidade).
          </Typography>
        </Paper>
      }

      <Typography variant='content2' italic inheritColor customClassName='requiredInfoText'>
        *Preenchimento obrigatório
      </Typography>

      <Button
        variant='contained'
        disabled={reason.length < 5}
        color='danger'
        onClick={onSubmit}
      >
        CONFIRMAR CANCELAMENTO
      </Button>
      
    </S.CancelReservationFormWrapper>
  )
}